// Tagalog strings for the fieldB area (field-facing screens only). Keyed by the English source text; {name} placeholders stay as-is.
// Screens: physical audit walk, first scan walk binding (+ walk exception modal), blind counts (+ RFID import, variance threshold).
export default {
  "(+{count} more)": "(+{count} pa)",
  "(Counted: {counted}, Book Stock: {book} on a {par} Par base). Audit Exception {ref} has been flagged for Property Manager investigation.": "(Nabilang: {counted}, Stock sa libro: {book} sa {par} na par). Ang Audit Exception {ref} ay na-flag para imbestigahan ng Property Manager.",
  "(Overdue)": "(Lampas na)",
  "(default)": "(default)",
  "(no reads)": "(walang nabasa)",
  "(optional)": "(opsyonal)",
  "(set for your organisation)": "(itinakda para sa inyong organisasyon)",
  "Absent": "Wala",
  "Action": "Aksyon",
  "Actions": "Mga aksyon",
  "Active Stock Count & Variance Sessions": "Mga aktibong sesyon ng bilang at variance",
  "Add photo (optional, JPEG, PNG or WebP up to 5 MB)": "Magdagdag ng litrato (opsyonal, JPEG, PNG o WebP hanggang 5 MB)",
  "Add pooled items to a stock point before logging breakage": "Magdagdag ng pooled items sa stock point bago mag-log ng sira",
  "Also read, but not held here: {items}. Transfer them first if they belong to this Stock Point.": "Nabasa rin pero wala rito: {items}. Ilipat muna kung kabilang sa Stock Point na ito.",
  "Asset": "Asset",
  "Asset Item & Tag": "Asset item at tag",
  "Asset Lifecycle Status": "Status ng lifecycle ng asset",
  "Asset tag": "Asset tag",
  "Assigned Asset Tag": "Naka-assign na asset tag",
  "Attach Photo Evidence": "Maglakip ng litratong ebidensya",
  "Audit Batch": "Audit batch",
  "Audit Exception {ref} is now under investigation.": "Iniimbestigahan na ang Audit Exception {ref}.",
  "Audit Now": "I-audit ngayon",
  "Audit Type": "Uri ng audit",
  "Audit Variance Threshold Exceeded (>{pct}% Tolerance Breach)": "Lumampas sa audit variance threshold (>{pct}% na tolerance)",
  "Audit Walk": "Audit walk",
  "Audit scan {tag}": "Audit scan {tag}",
  "Audit scan {tag} in {room}": "Audit scan {tag} sa {room}",
  "Audits": "Mga audit",
  "BOM: {bom}": "BOM: {bom}",
  "Bind Physical Tag": "I-bind ang pisikal na tag",
  "Binding Progress": "Progreso ng pag-bind",
  "Binding is never blocked.": "Hindi kailanman hinaharangan ang pag-bind.",
  "Blind Counts": "Blind counts",
  "Blind Counts & Variance Console": "Blind counts at variance console",
  "Blind count - {stockPoint} ({count} item)": "Blind count - {stockPoint} ({count} item)",
  "Blind count - {stockPoint} ({count} items)": "Blind count - {stockPoint} ({count} item)",
  "Blind count submitted successfully ({ref}). All counted items are within the {threshold}% tolerance.": "Matagumpay na naisumite ang blind count ({ref}). Lahat ng nabilang ay pasok sa {threshold}% na tolerance.",
  "Book / Counted": "Libro / Nabilang",
  "Book Qty": "Dami sa libro",
  "Bound": "Naka-bind",
  "Breakage event {ref} logged and stock decremented by {quantity} units. Total loss: {loss}.": "Na-log ang sira {ref} at nabawasan ang stock ng {quantity} unit. Kabuuang lugi: {loss}.",
  "Cadence": "Iskedyul",
  "Cadence Engine": "Cadence engine",
  "Camera preview": "Preview ng camera",
  "Camera scan failed: {reason}. Enter the 6-character short code instead.": "Pumalya ang camera scan: {reason}. I-type na lang ang 6-character na short code.",
  "Camera scanning is not supported on this device. Use a hardware scanner or enter the short code.": "Hindi suportado ang camera scan sa device na ito. Gumamit ng hardware scanner o i-type ang short code.",
  "Camera unavailable": "Hindi magamit ang camera",
  "Camera unavailable ({reason}). Use a handheld scanner or type the code.": "Hindi magamit ang camera ({reason}). Gumamit ng handheld scanner o i-type ang code.",
  "Cancel": "Kanselahin",
  "Category": "Kategorya",
  "Category: {category} | UoM: {uom}": "Kategorya: {category} | UoM: {uom}",
  "Change": "Baguhin",
  "Check the file": "Suriin ang file",
  "Choose the Stock Point that was read": "Piliin ang Stock Point na binasa",
  "Choose the reader export file": "Piliin ang export file ng reader",
  "Close": "Isara",
  "Condition Grade": "Grado ng kondisyon",
  "Condition of {item}": "Kondisyon ng {item}",
  "Confirm Tag Binding": "Kumpirmahin ang pag-bind ng tag",
  "Confirm Write-Off": "Kumpirmahin ang write-off",
  "Contractor handover": "Handover ng kontratista",
  "Could not read the selected photo": "Hindi mabasa ang napiling litrato",
  "Could not read {file}": "Hindi mabasa ang {file}",
  "Count a Stock Point from a handheld RFID reader export": "Bilangin ang Stock Point mula sa export ng handheld RFID reader",
  "Count recorded ({ref}):": "Naitala ang bilang ({ref}):",
  "Count sheet saved for offline use on {date}.": "Na-save ang count sheet para offline noong {date}.",
  "Count with an RFID reader": "Magbilang gamit ang RFID reader",
  "Count {ref} - {item}": "Bilang {ref} - {item}",
  "Counted": "Nabilang",
  "Counted Qty": "Nabilang na dami",
  "Counted at": "Oras ng bilang",
  "Counted by": "Binilang ni",
  "Custody Handover": "Handover ng custody",
  "Cycle Count Batch:": "Batch ng cycle count:",
  "Damage photo attached": "May nakalakip na litrato ng sira",
  "Damage photo of {item}": "Litrato ng sira ng {item}",
  "Different Model Found": "Ibang modelo ang nakita",
  "Different model": "Ibang modelo",
  "Different model · catalogue review": "Ibang modelo · review ng catalogue",
  "Different model?": "Ibang modelo?",
  "Discarded Quantity": "Dami ng itinapon",
  "Due Date": "Takdang petsa",
  "Enter 6-char short code (e.g. {code}) or scan QR code payload.": "I-type ang 6-char na short code (hal. {code}) o i-scan ang QR code.",
  "Enter a whole number of at least 1": "Maglagay ng buong numero na hindi bababa sa 1",
  "Enter a whole number, zero or more": "Maglagay ng buong numero, zero o higit pa",
  "Enter the counted quantity for at least one item": "Ilagay ang nabilang na dami para sa kahit isang item",
  "Enter the make or model you actually found.": "Ilagay ang brand o modelong talagang nakita mo.",
  "Enter verified count": "Ilagay ang beripikadong bilang",
  "Every asset in this room already has a tag.": "May tag na ang bawat asset sa kuwartong ito.",
  "Exception": "Exception",
  "Exception (>{pct}%)": "Exception (>{pct}%)",
  "Exception Status": "Status ng exception",
  "Execute Blind Count": "Isagawa ang blind count",
  "Expected Space": "Inaasahang lugar",
  "Expected system quantities are hidden from field counter to enforce strict blind count integrity.": "Nakatago sa nagbibilang ang inaasahang dami sa system para manatiling tapat ang blind count.",
  "Export Sheet": "I-export ang sheet",
  "Extra Item Recorded": "Naitala ang sobrang item",
  "Extra items found here (not registered)": "Mga sobrang item na nakita rito (hindi rehistrado)",
  "Fair": "Katamtaman",
  "First Scan": "Unang scan",
  "First Scan Walk Active": "Aktibo ang first scan walk",
  "First Scan Walk Binding": "Pag-bind sa first scan walk",
  "Flag for review": "I-flag para i-review",
  "Flagged - not moved": "Na-flag - hindi inilipat",
  "Flagged for Review": "Na-flag para i-review",
  "Found here": "Nakita rito",
  "Found in Another Room": "Nakita sa ibang kuwarto",
  "Found in the wrong room": "Nakita sa maling kuwarto",
  "Found it": "Nakita na",
  "Good": "Maayos",
  "Highlights the next expected item. Nothing is recorded until you scan or tick it.": "Ipinapakita ang susunod na inaasahang item. Walang naitatala hangga't hindi mo ito ini-scan o tini-tick.",
  "Import RFID Reads": "Mag-import ng RFID reads",
  "Investigate": "Imbestigahan",
  "Item": "Item",
  "Item Absent": "Walang item",
  "Item Blueprint": "Blueprint ng item",
  "Item Name": "Pangalan ng item",
  "Item absent": "Walang item",
  "Item to Count: {item}": "Item na bibilangin: {item}",
  "Item {item}": "Item {item}",
  "Kit expected {model}": "Inaasahan ng kit ang {model}",
  "Launch Walk": "Simulan ang walk",
  "Load Room": "I-load ang kuwarto",
  "Loading checklist…": "Nilo-load ang checklist…",
  "Loading count sessions...": "Nilo-load ang mga sesyon ng bilang...",
  "Loading scheduled audit tasks...": "Nilo-load ang mga naka-iskedyul na audit task...",
  "Located in {room}": "Nasa {room}",
  "Location": "Lokasyon",
  "Log Breakage Event": "Mag-log ng sira",
  "Log Point of Event Breakage": "I-log ang sira sa mismong event",
  "Loss exceeds {limit}: an approval task was routed to the Department Head.": "Lampas sa {limit} ang lugi: may approval task na ipinadala sa Department Head.",
  "Make found": "Brand na nakita",
  "Manage Schedules & Coverage": "Pamahalaan ang iskedyul at saklaw",
  "Manufacturer Serial #": "Serial # ng manufacturer",
  "Manufacturer Serial Number": "Serial number ng manufacturer",
  "Mark Absent": "Markahang wala",
  "Missing": "Nawawala",
  "Model found": "Modelong nakita",
  "Move Not Recorded": "Hindi naitala ang paglipat",
  "Move here": "Ilipat dito",
  "Move here needs a connection; the item stays flagged until then.": "Kailangan ng koneksyon para ilipat dito; mananatiling naka-flag ang item hanggang doon.",
  "Moved Here": "Nailipat dito",
  "Moved here": "Nailipat dito",
  "My Scheduled Audit Tasks": "Aking mga naka-iskedyul na audit task",
  "My Scheduled Audits": "Aking mga naka-iskedyul na audit",
  "Next": "Susunod",
  "Next expected: {name} ({code}). Find it, then scan or tick it.": "Susunod na inaasahan: {name} ({code}). Hanapin ito, saka i-scan o i-tick.",
  "No assets are registered to this space.": "Walang asset na nakarehistro sa lugar na ito.",
  "No blind counts recorded yet.": "Wala pang naitalang blind count.",
  "No blind counts recorded yet. Set up a stock point first, then start a blind count.": "Wala pang naitalang blind count. Mag-set up muna ng stock point, saka magsimula ng blind count.",
  "No floor": "Walang palapag",
  "No open audit batches": "Walang bukas na audit batch",
  "No overdue audit tasks.": "Walang lampas na audit task.",
  "No pooled items are held at this stock point.": "Walang pooled item sa stock point na ito.",
  "No property is loaded yet": "Wala pang na-load na property",
  "No room selected.": "Walang napiling kuwarto.",
  "No rooms have been stamped with a Room Kit yet. Stamp a kit to a room, then start the walk.": "Wala pang kuwartong na-stamp ng Room Kit. Mag-stamp ng kit sa kuwarto, saka simulan ang walk.",
  "No scheduled audit tasks are assigned to you.": "Walang naka-iskedyul na audit task na naka-assign sa iyo.",
  "No stamped rooms.": "Walang na-stamp na kuwarto.",
  "No stock points yet — set one up in": "Wala pang stock point — mag-set up sa",
  "None": "Wala",
  "None of the chips belong to an item held at this Stock Point. A storekeeper maps chips to items on the Stock Points screen.": "Wala sa mga chip ang kabilang sa item ng Stock Point na ito. Ang storekeeper ang nagma-map ng chip sa item sa Stock Points screen.",
  "Not recorded": "Hindi naitala",
  "Note": "Tala",
  "Nothing has been moved yet.": "Wala pang inilipat.",
  "Offline": "Offline",
  "Offline Mode": "Offline mode",
  "Offline Scans Synced": "Na-sync ang mga offline scan",
  "Offline: tag {tag} for {asset} is saved on this device and is bound when you are back online.": "Offline: naka-save sa device na ito ang tag {tag} para sa {asset} at ibi-bind pagbalik online.",
  "Onboarding walk console: scan physical room barcodes, inspect template-stamped draft assets, and bind physical QR tags to activate fixed assets.": "Console ng onboarding walk: i-scan ang barcode ng kuwarto, suriin ang mga draft asset mula sa template, at i-bind ang pisikal na QR tag para i-activate ang fixed asset.",
  "Open a room by scanning its tag, then scan or tick every expected item with its condition. Items found in the wrong room are never moved without your choice.": "Buksan ang kuwarto sa pag-scan ng tag nito, saka i-scan o i-tick ang bawat inaasahang item kasama ang kondisyon. Hindi kailanman inililipat ang item na nasa maling kuwarto nang walang pasya mo.",
  "Open a room first: scan its tag or type its code.": "Magbukas muna ng kuwarto: i-scan ang tag o i-type ang code.",
  "Open room": "Buksan ang kuwarto",
  "Or pick the room:": "O piliin ang kuwarto:",
  "Or select a stamped room from the walk list": "O pumili ng na-stamp na kuwarto sa walk list",
  "Outlet Audit": "Audit ng outlet",
  "Overdue audits are escalated to the schedule's Department Head.": "Ang mga lampas na audit ay ini-escalate sa Department Head ng iskedyul.",
  "Owner handover": "Handover ng may-ari",
  "Page {page} - {total} counted lines": "Pahina {page} - {total} nabilang na linya",
  "Par Level": "Par level",
  "Pending Scan": "Hinihintay ang scan",
  "Pending Tasks": "Mga nakabinbing task",
  "Photo": "Litrato",
  "Photos must be JPEG, PNG or WebP images": "Dapat JPEG, PNG o WebP ang mga litrato",
  "Photos must be JPEG, PNG or WebP images.": "Dapat JPEG, PNG o WebP ang mga litrato.",
  "Photos need a connection, so it was saved without one.": "Kailangan ng koneksyon ang litrato, kaya na-save ito nang wala nito.",
  "Photos need a connection. While offline the item is saved as damaged without a photo.": "Kailangan ng koneksyon ang litrato. Habang offline, ise-save ang item bilang sira nang walang litrato.",
  "Physical Audit": "Pisikal na audit",
  "Physical Audit Verification & Schedules": "Pisikal na audit verification at iskedyul",
  "Physical Condition": "Pisikal na kondisyon",
  "Physically Counted Quantity": "Aktwal na nabilang na dami",
  "Point camera or scan tag": "Itutok ang camera o i-scan ang tag",
  "Pooled Item Name": "Pangalan ng pooled item",
  "Poor": "Sira",
  "Previous": "Nakaraan",
  "Progress:": "Progreso:",
  "Property": "Property",
  "RFID count {ref} submitted for {stockPoint}: {lines} item(s) from {chips} chips, {exceptions} over the variance threshold.": "Naisumite ang RFID count {ref} para sa {stockPoint}: {lines} item mula sa {chips} chip, {exceptions} lampas sa variance threshold.",
  "RFID count {ref} submitted for {stockPoint}: {lines} item(s) from {chips} chips.": "Naisumite ang RFID count {ref} para sa {stockPoint}: {lines} item mula sa {chips} chip.",
  "Reader export (CSV or text)": "Export ng reader (CSV o text)",
  "Reason Code": "Reason code",
  "Recent count session in": "Ang kamakailang bilang sa",
  "Record": "Itala",
  "Record Model": "Itala ang modelo",
  "Record {item} as damaged": "Itala ang {item} bilang sira",
  "Remove": "Alisin",
  "Review": "I-review",
  "Room": "Kuwarto",
  "Room Audit": "Audit ng kuwarto",
  "Room Door Code (QR / Barcode / Room Number)": "Code sa pinto (QR / Barcode / Numero ng kuwarto)",
  "Room Opened": "Nabuksan ang kuwarto",
  "Room Signed Off": "Na-sign off ang kuwarto",
  "Room kit": "Room kit",
  "Room sign-off - {room}": "Sign-off ng kuwarto - {room}",
  "Rooms assigned to you by recurring audit schedules. Launch a walk to verify a room; signing it off completes the task.": "Mga kuwartong naka-assign sa iyo mula sa paulit-ulit na audit schedule. Magsimula ng walk para i-verify ang kuwarto; ang pag-sign off ang tatapos sa task.",
  "Run blind stock counts, flag variances above {threshold}% and log breakage.": "Magsagawa ng blind count, i-flag ang variance na lampas {threshold}% at i-log ang sira.",
  "Save": "I-save",
  "Save as Damaged": "I-save bilang sira",
  "Saved Offline": "Na-save offline",
  "Saving...": "Sine-save...",
  "Scan & Bind": "I-scan at i-bind",
  "Scan Items": "I-scan ang mga item",
  "Scan Not Recorded": "Hindi naitala ang scan",
  "Scan Physical QR Tag (ULID / Short Code)": "I-scan ang pisikal na QR tag (ULID / Short code)",
  "Scan Room Code": "I-scan ang code ng kuwarto",
  "Scan a room code or select a stamped room to start the walk.": "I-scan ang code ng kuwarto o pumili ng na-stamp na kuwarto para simulan ang walk.",
  "Scan an item from elsewhere": "I-scan ang item mula sa ibang lugar",
  "Scan an item tag, or tick an item on the checklist": "I-scan ang tag ng item, o i-tick ang item sa checklist",
  "Scan or enter a room code": "I-scan o i-type ang code ng kuwarto",
  "Scan or enter the physical tag": "I-scan o i-type ang pisikal na tag",
  "Scan or select a room first to bind its tags.": "Mag-scan o pumili muna ng kuwarto para i-bind ang mga tag nito.",
  "Scan or type the item tag or short code": "I-scan o i-type ang tag o short code ng item",
  "Scan the tag of an item that is here but belongs to another room": "I-scan ang tag ng item na nandito pero taga-ibang kuwarto",
  "Scan with a handheld scanner into the field below, use the camera, or type the short code printed under the tag.": "Mag-scan gamit ang handheld scanner sa field sa ibaba, gamitin ang camera, o i-type ang short code sa ilalim ng tag.",
  "Scan with camera": "I-scan gamit ang camera",
  "Schedule": "Iskedyul",
  "Select Start Blind Count to begin.": "Piliin ang Start Blind Count para magsimula.",
  "Select Stock Point": "Piliin ang Stock Point",
  "Select an audit batch and a room to load its checklist.": "Pumili ng audit batch at kuwarto para i-load ang checklist nito.",
  "Select an audit batch and room to sign off": "Pumili ng audit batch at kuwarto para mag-sign off",
  "Select an item": "Pumili ng item",
  "Select the draft asset to bind": "Piliin ang draft asset na ibi-bind",
  "Serialized Asset Checklist": "Checklist ng serialized asset",
  "Session Ref": "Ref ng sesyon",
  "Set up a stock point first": "Mag-set up muna ng stock point",
  "Shift handover": "Handover ng shift",
  "Show next expected": "Ipakita ang susunod",
  "Showing the checklist saved for offline use on {date}. Results sync when you are back online.": "Ipinapakita ang checklist na na-save para offline noong {date}. Masi-sync ang resulta pagbalik online.",
  "Showing the checklist saved for offline use. Results sync when you are back online.": "Ipinapakita ang checklist na na-save para offline. Masi-sync ang resulta pagbalik online.",
  "Sign off with items missing": "Mag-sign off kahit may nawawalang item",
  "Sign off {room}": "I-sign off ang {room}",
  "Sign-Off Failed": "Pumalya ang sign-off",
  "Sign-Off Queued": "Naka-queue ang sign-off",
  "Sign-Off {room}": "I-sign off ang {room}",
  "Skipped lines: {lines}": "Nilaktawang linya: {lines}",
  "Spot Check": "Spot check",
  "Stamped Assets Awaiting Tag Binding": "Mga na-stamp na asset na naghihintay ng tag",
  "Stamped Kit Active": "Aktibo ang na-stamp na kit",
  "Stamped Template:": "Na-stamp na template:",
  "Stamped from Room Kit": "Na-stamp mula sa Room Kit",
  "Start Blind Count": "Simulan ang blind count",
  "Start here: scan the room's tag or type its code": "Magsimula rito: i-scan ang tag ng kuwarto o i-type ang code nito",
  "Status": "Status",
  "Stock Point Location": "Lokasyon ng Stock Point",
  "Stock Point that was read": "Stock Point na binasa",
  "Stock Points & Par Management": "Stock Points at par management",
  "Stock point": "Stock point",
  "Stop camera": "Ihinto ang camera",
  "Store Audit": "Audit ng store",
  "Submit Counted Quantities": "Isumite ang mga nabilang",
  "Submit as blind count": "Isumite bilang blind count",
  "Submitting...": "Isinusumite...",
  "Sweep the Stock Point with the handheld reader, export the reads as CSV (one EPC per row; antenna and time columns are optional) and choose the file. Each RFID chip is counted once, however often it was read.": "I-sweep ang Stock Point gamit ang handheld reader, i-export ang reads bilang CSV (isang EPC bawat linya; opsyonal ang antenna at oras) at piliin ang file. Isang beses lang binibilang ang bawat RFID chip kahit ilang beses nabasa.",
  "Sync Completed With Issues": "Natapos ang sync nang may problema",
  "Sync status": "Status ng sync",
  "Syncing": "Nagsi-sync",
  "Tag {tag} bound to {asset}. The asset is now in_service.": "Na-bind ang tag {tag} sa {asset}. In service na ang asset.",
  "Tag {tag} is not registered at this property. It was recorded as an Extra item in {room} ({ref}) for a manager to resolve.": "Hindi rehistrado ang tag {tag} sa property na ito. Naitala ito bilang sobrang item sa {room} ({ref}) para ayusin ng manager.",
  "Tag {tag} queued and will be checked when you are back online (it may belong to another room or be an extra item).": "Naka-queue ang tag {tag} at susuriin pagbalik online (maaaring taga-ibang kuwarto o sobrang item).",
  "Tag {tag} to {asset}": "Tag {tag} sa {asset}",
  "Tag {tag} to {asset} in {room}": "Tag {tag} sa {asset} sa {room}",
  "Tag: {tag}": "Tag: {tag}",
  "Tap NFC tag": "I-tap ang NFC tag",
  "Tap item NFC tag": "I-tap ang NFC tag ng item",
  "Tap room NFC tag": "I-tap ang NFC tag ng kuwarto",
  "Tap the Stock Point's NFC tag": "I-tap ang NFC tag ng Stock Point",
  "Target Draft Asset": "Target na draft asset",
  "That tag is not on a Stock Point of this property": "Wala sa Stock Point ng property na ito ang tag na iyan",
  "The file is larger than 8 MB. Export a smaller batch of reads from the reader.": "Lampas sa 8 MB ang file. Mag-export ng mas maliit na batch ng reads mula sa reader.",
  "The item is a different make or model than the kit lists (record it after binding)": "Iba ang brand o modelo ng item kaysa sa nakalista sa kit (itala pagkatapos i-bind)",
  "The item is here but is another make or model than the kit lists. The asset records what you found and the line is flagged for catalogue review. Bind its tag as usual.": "Nandito ang item pero iba ang brand o modelo sa nakalista sa kit. Itatala ng asset ang nakita mo at ifa-flag ang linya para sa review ng catalogue. I-bind ang tag gaya ng dati.",
  "The item is not in the room. It stays unbound and is flagged as missing so it can be followed up; nothing is deleted. If it turns up later, choose “Found it” and bind its tag.": "Wala ang item sa kuwarto. Mananatili itong hindi naka-bind at naka-flag na nawawala para ma-follow up; walang binubura. Kung lumitaw ito mamaya, piliin ang “Nakita na” at i-bind ang tag.",
  "The whole Stock Point was swept: count items with no reads as 0": "Na-sweep ang buong Stock Point: bilangin bilang 0 ang item na walang nabasa",
  "There are no open audit batches. An audit batch is opened from Audit Schedules (or by an auditor) before a walk can start.": "Walang bukas na audit batch. Binubuksan ang audit batch mula sa Audit Schedules (o ng auditor) bago makapagsimula ng walk.",
  "This browser cannot read tags with the camera. Use a handheld scanner or type the code printed under the tag.": "Hindi kayang basahin ng browser na ito ang tag gamit ang camera. Gumamit ng handheld scanner o i-type ang code sa ilalim ng tag.",
  "This room has no stamped assets to bind.": "Walang na-stamp na asset na ibi-bind sa kuwartong ito.",
  "This room has no stamped assets.": "Walang na-stamp na asset sa kuwartong ito.",
  "Tick as present with the condition shown": "I-tick bilang naroroon sa ipinakitang kondisyon",
  "Tick {item} as present": "I-tick ang {item} bilang naroroon",
  "Toggle Sound Feedback": "I-on/off ang tunog",
  "Toggle sound feedback": "I-on/off ang tunog",
  "Tolerance: {pct}%": "Tolerance: {pct}%",
  "Total Write-Off Loss Amount:": "Kabuuang halaga ng lugi sa write-off:",
  "Unbound Draft": "Draft na hindi naka-bind",
  "Unknown": "Hindi alam",
  "Upgrading to {plan} covers them. Binding is never blocked.": "Sakop ang mga ito kung mag-upgrade sa {plan}. Hindi kailanman hinaharangan ang pag-bind.",
  "Use camera": "Gamitin ang camera",
  "Variance": "Variance",
  "Variance %": "Variance %",
  "Variance rule: >{pct}% of book stock": "Panuntunan sa variance: >{pct}% ng stock sa libro",
  "Variance threshold (%)": "Variance threshold (%)",
  "Variance threshold:": "Variance threshold:",
  "Verified": "Beripikado",
  "Verified (queued)": "Beripikado (naka-queue)",
  "Verified (ticked)": "Beripikado (tinick)",
  "Verified Successfully!": "Matagumpay na na-verify!",
  "View": "Tingnan",
  "Walk": "Walk",
  "Within Par": "Pasok sa par",
  "You are offline and audits were not prepared for offline use on this device.": "Offline ka at hindi naihanda ang mga audit para sa offline sa device na ito.",
  "You are offline and this room code is not in the rooms prepared for offline use.": "Offline ka at wala ang code ng kuwartong ito sa mga kuwartong inihanda para sa offline.",
  "You are offline and this room was not prepared for offline use. Use Prepare for offline on the Sync status page before the walk.": "Offline ka at hindi naihanda ang kuwartong ito para sa offline. Gamitin ang Prepare for offline sa Sync status page bago ang walk.",
  "You are offline and this space was not prepared for offline use, so its checklist is not available. Scans are queued and checked on reconnection. Use Prepare for offline on the Sync status page before a shift.": "Offline ka at hindi naihanda ang lugar na ito para sa offline, kaya wala ang checklist nito. Naka-queue ang mga scan at susuriin pagbalik ng koneksyon. Gamitin ang Prepare for offline sa Sync status page bago ang shift.",
  "You are offline and this stock point was not prepared for offline use. Use Prepare for offline on the Sync status page before counting offline.": "Offline ka at hindi naihanda ang stock point na ito para sa offline. Gamitin ang Prepare for offline sa Sync status page bago magbilang offline.",
  "You are offline: the count for {stockPoint} is saved on this device and will be submitted automatically when you are back online.": "Offline ka: naka-save sa device na ito ang bilang para sa {stockPoint} at awtomatikong isusumite pagbalik online.",
  "Your plan covers {limit} tagged assets and {used} are now tagged.": "Sakop ng plano mo ang {limit} na naka-tag na asset at {used} na ang naka-tag.",
  "another model": "ibang modelo",
  "belongs to {room} but was scanned in": "ay taga-{room} pero na-scan sa",
  "closed": "sarado",
  "counts are saved on this device and submitted when you are back online": "naka-save sa device na ito ang mga bilang at isusumite pagbalik online",
  "detected a": "ay nakakita ng",
  "distinct chips": "magkakaibang chip",
  "draft": "draft",
  "e.g. {code}": "hal. {code}",
  "e.g. {code} or {number}": "hal. {code} o {number}",
  "fair": "katamtaman",
  "good": "maayos",
  "in_service": "in service",
  "kit expects {model}": "inaasahan ng kit ang {model}",
  "n/a": "n/a",
  "not mapped to an item": "hindi naka-map sa item",
  "on": "sa",
  "pending investigation": "naghihintay ng imbestigasyon",
  "poor": "sira",
  "reads": "nabasa",
  "resolved": "naayos na",
  "room": "kuwarto",
  "stock point": "stock point",
  "tags you bind are saved on this device and synced when you are back online": "naka-save sa device na ito ang mga tag na ibi-bind mo at masi-sync pagbalik online",
  "this stock point": "stock point na ito",
  "to start counting.": "para magsimulang magbilang.",
  "under investigation": "iniimbestigahan",
  "where it had been flagged missing": "kung saan ito na-flag na nawawala",
  "{applied} queued transaction synced, {failed} need your attention on the Sync status page.": "Na-sync ang {applied} naka-queue na transaksyon, {failed} ang kailangang tingnan sa Sync status page.",
  "{applied} queued transaction synced.": "Na-sync ang {applied} naka-queue na transaksyon.",
  "{applied} queued transactions synced, {failed} need your attention on the Sync status page.": "Na-sync ang {applied} naka-queue na transaksyon, {failed} ang kailangang tingnan sa Sync status page.",
  "{applied} queued transactions synced.": "Na-sync ang {applied} naka-queue na transaksyon.",
  "{asset} found. Bind its tag now.": "Nakita ang {asset}. I-bind na ang tag nito.",
  "{asset} marked absent. It stays unbound and is flagged as missing.": "Minarkahang wala ang {asset}. Mananatili itong hindi naka-bind at naka-flag na nawawala.",
  "{asset} stays registered to {room}; a manager reviews the relocation in the exception queue.": "Mananatiling nakarehistro ang {asset} sa {room}; susuriin ng manager ang paglipat sa exception queue.",
  "{asset}: actual make/model recorded and flagged for catalogue review.": "{asset}: naitala ang aktwal na brand/modelo at na-flag para sa review ng catalogue.",
  "{asset}: saved on this device while offline. It is recorded when you are back online.": "{asset}: na-save sa device na ito habang offline. Maitatala ito pagbalik online.",
  "{bound} / {total} Tagged Bound": "{bound} / {total} naka-tag at naka-bind",
  "{count} Overdue Audit Task:": "{count} lampas na audit task:",
  "{count} Overdue Audit Tasks:": "{count} lampas na audit task:",
  "{count} absent": "{count} wala",
  "{count} binding waiting to sync": "{count} pag-bind na naghihintay ng sync",
  "{count} bindings waiting to sync": "{count} pag-bind na naghihintay ng sync",
  "{count} count waiting to be submitted": "{count} bilang na naghihintay maisumite",
  "{count} counts waiting to be submitted": "{count} bilang na naghihintay maisumite",
  "{count} different model": "{count} ibang modelo",
  "{count} offline action needs your attention: the record changed before it could be synced.": "{count} offline na aksyon ang kailangang tingnan: nagbago ang record bago ito na-sync.",
  "{count} offline actions need your attention: the record changed before it could be synced.": "{count} offline na aksyon ang kailangang tingnan: nagbago ang record bago ito na-sync.",
  "{count} other action": "{count} iba pang aksyon",
  "{count} other actions": "{count} iba pang aksyon",
  "{count} sign-off": "{count} sign-off",
  "{file} is larger than 5 MB.": "Lampas sa 5 MB ang {file}.",
  "{item} variance is {variance} units ({pct}). Exceeds {threshold}% par threshold: Audit Exception #{ref} created ({status}).": "Ang variance ng {item} ay {variance} unit ({pct}). Lampas sa {threshold}% na par threshold: nagawa ang Audit Exception #{ref} ({status}).",
  "{location} was due on": "Ang {location} ay takdang gawin noong",
  "{mode} - {count} scan queued locally": "{mode} - {count} scan na naka-queue sa device",
  "{mode} - {count} scans queued locally": "{mode} - {count} scan na naka-queue sa device",
  "{pct} variance": "{pct} na variance",
  "{ref} - waiting for a manager in the exception queue": "{ref} - naghihintay ng manager sa exception queue",
  "{room} Stamped Assets Awaiting Tag Binding": "Mga na-stamp na asset sa {room} na naghihintay ng tag",
  "{room} inspection signed off: {verified} verified, {missing} missing, {mislocated} mislocated. Room compliance {pct}%.": "Na-sign off ang inspeksyon ng {room}: {verified} beripikado, {missing} nawawala, {mislocated} nasa maling lugar. Pagsunod ng kuwarto {pct}%.",
  "{room} is open. Scan or tick each expected item.": "Bukas na ang {room}. I-scan o i-tick ang bawat inaasahang item.",
  "{room} loaded - {count} draft asset(s) awaiting a tag.": "Na-load ang {room} - {count} draft asset ang naghihintay ng tag.",
  "{room} sign-off will be committed when the connection returns.": "Maitatala ang sign-off ng {room} pagbalik ng koneksyon.",
  "{tagged} Tagged Assets, {pooled} Pooled Lines": "{tagged} naka-tag na asset, {pooled} pooled na linya",
  "{tag} belongs to {location}. It has not been moved: choose Move here or Flag for review.": "Ang {tag} ay taga-{location}. Hindi pa ito inilipat: piliin ang Ilipat dito o I-flag para i-review.",
  "{tag} marked verified in {room} as damaged with a photo.": "Na-verify ang {tag} sa {room} bilang sira, may litrato.",
  "{tag} marked verified in {room} as damaged.": "Na-verify ang {tag} sa {room} bilang sira.",
  "{tag} marked verified in {room}.": "Na-verify ang {tag} sa {room}.",
  "{tag} now belongs to {to} (moved from {from}).": "Ang {tag} ay nasa {to} na ngayon (inilipat mula sa {from}).",
  "{tag} now belongs to {to}.": "Ang {tag} ay nasa {to} na ngayon.",
  "{tag} verified locally and queued for sync.": "Na-verify ang {tag} sa device at naka-queue para sa sync.",
  "{verified} of {expected} ({pct}%)": "{verified} sa {expected} ({pct}%)",
  "{verified} of {expected} Assets Verified ({pct}%)": "{verified} sa {expected} asset ang na-verify ({pct}%)",
};
